module.exports = __webpack_public_path__ + "images/dashboard-filter-87f16ea95bde9e64b4bf6d400ee6ed4f.png";